import { motion } from 'framer-motion';
import { Star, MapPin, Shield, Phone, ArrowDown } from 'lucide-react';

const HERO_BG = 'https://static.prod-images.emergentagent.com/jobs/e17238f4-6670-41c0-9f2d-00e20837d10a/images/b0934d92a5971f1e8fcca61d12c3c981ae65774408104b6d34bae41b31d020cf.png';

const Hero = () => {
  return (
    <section id="top" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-testid="hero-section">
      <div className="absolute inset-0 z-0">
        <img src={HERO_BG} alt="Vibrant colorful tour adventure background" className="w-full h-full object-cover" loading="eager" />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto py-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-caveat text-2xl sm:text-3xl text-[#FFD600] mb-4" data-testid="hero-subtitle">
            The #1 Rated Day Trip from Las Vegas
          </p>
          <h1 className="font-bebas text-5xl sm:text-6xl lg:text-8xl tracking-tighter uppercase text-white leading-none mb-3" data-testid="hero-heading">
            VEGAS <span className="text-[#FFD600]">TO</span> HOLLYWOOD
          </h1>
          <p className="font-bebas text-xl sm:text-2xl lg:text-3xl tracking-tight uppercase text-[#00E5FF] mb-6" data-testid="hero-tagline">
            Turn One Day Into a Movie
          </p>
          <p className="font-outfit text-base sm:text-lg lg:text-xl text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed speakable-intro">
            Ready to trade neon for palm trees and make your Vegas trip legendary?
            This isn't just a tour — it's a full-throttle, camera-ready adventure from Las Vegas
            to the heart of Hollywood. Think big energy, iconic stops, and nonstop "main character" moments.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
            <a
              href="#booking"
              onClick={(e) => {
                e.preventDefault();
                window.location.hash = 'booking';
              }}
              className="btn-primary px-8 py-4 text-base sm:text-lg animate-pulse-cta speakable-booking"
              data-testid="hero-book-now"
              aria-label="Book Vegas to Hollywood tour for $215 per person"
            >
              BOOK YOUR ADVENTURE - $215
            </a>
            <a
              href="tel:+18777418390"
              className="flex items-center gap-2 bg-white/10 backdrop-blur-md text-white font-outfit font-bold px-8 py-4 rounded-xl border-2 border-white/30 hover:bg-white/20 transition-all text-base speakable-price"
              data-testid="hero-call-now"
              aria-label="Call toll-free 1-877-741-8390 to book your tour"
            >
              <Phone className="w-5 h-5" aria-hidden="true" />
              1-877-741-8390
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10 mb-8">
            <div className="flex items-center gap-2 text-white/90">
              <Star className="w-5 h-5 text-[#FFD600] fill-[#FFD600]" />
              <span className="font-outfit text-sm font-medium">10,000+ Happy Travelers</span>
            </div>
            <div className="flex items-center gap-2 text-white/90">
              <MapPin className="w-5 h-5 text-[#00E5FF]" />
              <span className="font-outfit text-sm font-medium">100+ Hotel Pickups</span>
            </div>
            <div className="flex items-center gap-2 text-white/90">
              <Shield className="w-5 h-5 text-[#FF007A]" />
              <span className="font-outfit text-sm font-medium">Best Price Guarantee</span>
            </div>
          </div>
        </motion.div>

        <motion.a
          href="#features"
          onClick={(e) => {
            e.preventDefault();
            window.location.hash = 'features';
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 0.5 }}
          className="inline-block text-white/60 hover:text-white transition-colors"
          data-testid="hero-scroll-down"
        >
          <ArrowDown className="w-8 h-8 animate-bounce" />
        </motion.a>
      </div>
    </section>
  );
};

export default Hero;
